import moment from 'moment';

/**
 * Stored as the server's DateTime.ToString() in its culture ("26.09.2026 22:00:00" or
 * "9/26/2026 10:00:00 PM"), 01.01.0001 for unset. Read the date only: parsing the time in
 * the browser's zone made it creep two hours earlier on every save.
 */
export function parseExpiryDate(stored: string | null | undefined): moment.Moment | null {
  if (!stored) return null;

  const norwegian = /^(\d{1,2})\.(\d{1,2})\.(\d{4})/.exec(stored);
  const english = /^(\d{1,2})\/(\d{1,2})\/(\d{4})/.exec(stored);
  const iso = /^(\d{4})-(\d{2})-(\d{2})/.exec(stored);

  let year: number, month: number, day: number;
  if (norwegian) [year, month, day] = [+norwegian[3], +norwegian[2], +norwegian[1]];
  else if (english) [year, month, day] = [+english[3], +english[1], +english[2]];
  else if (iso) [year, month, day] = [+iso[1], +iso[2], +iso[3]];
  else return null;

  if (year < 1900) return null;
  const date = moment({ year, month: month - 1, day });
  return date.isValid() ? date : null;
}

/** Noon with no zone, so the server keeps the same calendar day whichever zone it or the browser is in. */
export function toExpiryInput(date: moment.Moment | null): string {
  return date ? `${date.format('YYYY-MM-DD')}T12:00:00` : '0001-01-01T00:00:00';
}
